module.exports = "<th>\n  Вход\n  <serp-filter-associated-objects filter-param=\"input_type\"/>\n</th>\n<td>\n  <terms items=\"::terms.input_type\" source=\"source.input_type\"/>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/commercial/input_type.html
// module id = 334
// module chunks = 0